/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'feedback-negative_big': {
    width: 16,
    height: 16,
    viewBox: '0 0 140 140',
    data: '<g _fill="none" fill-rule="evenodd"><g _fill="#FFF"><g><g><path pid="0" d="M70 64.343L50.555 44.898l-5.657 5.657L64.343 70 44.898 89.445l5.657 5.657L70 75.657l19.445 19.445 5.657-5.657L75.657 70l19.445-19.445-5.657-5.657L70 64.343zM70 140c-38.66 0-70-31.34-70-70S31.34 0 70 0s70 31.34 70 70-31.34 70-70 70z"/></g></g></g></g>'
  }
})
